import script from "./flightPackages.vue?vue&type=script&lang=ts&setup=true"
export * from "./flightPackages.vue?vue&type=script&lang=ts&setup=true"

import "./flightPackages.vue?vue&type=style&index=0&id=4f938fba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f938fba"]])

export default __exports__